import { render, staticRenderFns } from "./ProduktStapel.vue?vue&type=template&id=5890671a&"
import script from "./ProduktStapel.vue?vue&type=script&lang=js&"
export * from "./ProduktStapel.vue?vue&type=script&lang=js&"
import style0 from "./ProduktStapel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProduktStapel.vue"
export default component.exports